/** 舊版無 GPS 時寫入的台北預設點（勿當真實使用者或工匠位置） */
export const LEGACY_DEFAULT_TAIPEI = { lat: 25.033, lng: 121.5654 } as const;

/** 無定位時地圖全台視野（非搜索圓心） */
export const TAIWAN_MAP_VIEW = {
  lat: 23.975,
  lng: 120.973,
  zoom: 7,
} as const;

const EPS = 0.002;

export function isLegacyDefaultLocation(
  loc: { lat: number; lng: number } | null | undefined
): boolean {
  if (!loc) return false;
  return (
    Math.abs(loc.lat - LEGACY_DEFAULT_TAIPEI.lat) < EPS &&
    Math.abs(loc.lng - LEGACY_DEFAULT_TAIPEI.lng) < EPS
  );
}

export function isUsableUserGeoLocation(
  loc: { lat: number; lng: number } | null | undefined
): boolean {
  if (!loc) return false;
  if (!Number.isFinite(loc.lat) || !Number.isFinite(loc.lng)) return false;
  if (loc.lat === 0 && loc.lng === 0) return false;
  if (isLegacyDefaultLocation(loc)) return false;
  return loc.lat >= 21.9 && loc.lat <= 25.3 && loc.lng >= 119.3 && loc.lng <= 122.0;
}

export function isUsableProviderLocation(
  loc: { lat: number; lng: number } | null | undefined
): boolean {
  if (!isUsableUserGeoLocation(loc)) return false;
  return !isLegacyDefaultLocation(loc);
}

export function getChromeSiteLocationSettingsUrl(origin?: string): string {
  const site = (origin ?? (typeof window !== 'undefined' ? window.location.origin : 'https://techfix.com.tw')).replace(
    /\/$/,
    ''
  );
  return `chrome://settings/content/siteDetails?site=${encodeURIComponent(`${site}/`)}`;
}
